import { TCategory, TTopCategory } from 'data';
import { getTopCategoriesId } from '../get-top-categories-id';
import { findTopCategoryData } from '../find-data-helpers';
import { TConfigurator } from '../../containers/configurators-listing';

export const getPopularCardPosition = (
	popularCategories: TCategory[],
	searchCategoryId: number
): string =>
	String(popularCategories.findIndex(({ categoryId }) => categoryId === searchCategoryId) + 1);

export const getCatalogueCardPosition = (
	topCategories: TTopCategory[],
	selectedFilterItems: number[],
	searchCategoryId: number
) => {
	const topCategoriesArray = selectedFilterItems.length
		? selectedFilterItems
		: getTopCategoriesId(topCategories);

	let found = false;
	let cardPosition = 0;

	topCategoriesArray.forEach(topCategoryId => {
		if (found) return;

		const { categories } = findTopCategoryData(topCategories, topCategoryId);

		const categoryIndex = categories.findIndex(
			({ categoryId }) => categoryId === searchCategoryId
		);
		if (categoryIndex > -1) {
			cardPosition += categoryIndex + 1;
			found = true;
		} else {
			cardPosition += categories.length;
		}
	});

	return cardPosition.toString();
};

export const getConfiguratorPosition = (
	configurators: TConfigurator[],
	searchConfiguratorId: number
) => String(configurators.findIndex(({ id }) => id === searchConfiguratorId) + 1);
